import React from 'react';

import classes from './styles.module.css';

const Column = (props) => {
    const widthStyle = (() => {
        if (props.width === 'full') return { flex: 1, width: '100%' };
        if (props.width == null) return {};
        const w = String(props.width);
        if (/^\d+$/.test(w)) return { width: w + 'px' };
        return { width: w };
    })();
    return (
        <div style={widthStyle} className={`${classes.Column}${props.className ? ' ' + props.className : ''}`}>
            {props.children}
        </div>
    );
};

const Container = (props) => {
    return (
        <div style={props.style} className={`${classes.Container}${props.className ? ' ' + props.className : ''}`}>
            {props.children}
        </div>
    );
};

const Wrapper = (props) => {
    return (
        <div style={props.style} className={classes.Wrapper}>
            {props.children}
        </div>
    );
};

export { Wrapper, Column, Container };
export { default as RoleLayout } from './RoleLayout';
export { default as UserLayout } from './UserLayout';
export { default as AdminLayout } from './AdminLayout';
export { default as PublicLayout } from './PublicLayout';
export { LayoutScopeProvider, useLayoutScope } from './LayoutScopeContext';



// WEBPACK FOOTER //
// ./src/hoc/Layout/index.js